import { replaceDiImpl } from '@bcf-vanilla-ts-v1-shared/di/provide-singleton';
import { ActivatedModal as BcfActivatedModal } from '@bcf2-v1-ui-modal-shared/activated-modal';
import { provideBcfActivatedModalAdapter } from './bcf-activated-modal-adapter';

export function registerBcf2ModalAdapters(): void {
  replaceDiImpl(BcfActivatedModal, () => provideBcfActivatedModalAdapter());
}
